import { DestroyRef, Directive, ElementRef, EventEmitter, HostListener, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';
import { filter, map, skip } from 'rxjs/operators';

@Directive({
  selector: '[appOnlyNumbers]',
  exportAs: 'appOnlyNumbers'
})
export class OnlyNumbersDirective implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _withFloat = false;

  @Input() maxValue: number;
  @Input() allowMinus: boolean = true;
  @Input() skipValidation: boolean = false;
  @Input() customRegexStr: string;
  @Input() allowMultipleDots = false;
  @Input() decimalsNumber = 2;
  @Output() ngModelChange = new EventEmitter<number>();

  regexStr = '^[0-9_.,]*$';
  onlyNumbers = '^[0-9]*$';
  @Input() set withFloat(val) {
    this._withFloat = val;

    if (val) {
      this.regexStr = '^[0-9_.,]*$';
    } else {
      this.regexStr = '^[0-9_]*$';
    }
  }

  constructor(
    private _el: ElementRef,
    private _control: NgControl
  ) {}

  @HostListener('input', ['$event']) onKeyInput(event): boolean {
    const regExp =
      !this.allowMultipleDots && event.key === '.' && this._el.nativeElement.value.indexOf('.') !== -1
        ? this.onlyNumbers
        : this.regexStr;

    const value = this._el.nativeElement.value;

    if (!isNaN(value) && value.includes('.') && value.split('.')[1].length > this.decimalsNumber) {
      const decimalsNumberCoefficient = 10 ** this.decimalsNumber;
      const formattedValue = Math.floor(value * decimalsNumberCoefficient) / decimalsNumberCoefficient;
      this._el.nativeElement.value = formattedValue;
      event.stopPropagation();
      event.preventDefault();
      this.ngModelChange.emit(formattedValue);
      if (this._control.control) {
        this._control.control.setValue(formattedValue);
      }
    }

    return new RegExp(this.customRegexStr || regExp).test(event.key);
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (event.code === 'Minus' && !this.allowMinus) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent): void {
    this.validateMinus(event);
    this.validateFields(event);
  }

  @HostListener('focus', ['$event']) onFocus(event: FocusEvent): void {
    event.target.addEventListener('wheel', this.blockScroll, { passive: false });
  }

  @HostListener('blur', ['$event']) onBlur(event: FocusEvent): void {
    event.target.removeEventListener('wheel', this.blockScroll);
  }

  blockScroll(event: WheelEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  validateMinus(event): void {
    setTimeout(() => {
      const val = this._el.nativeElement.value;
      const numb = parseInt(val);
      if (!this.allowMinus && numb < 0) {
        this._el.nativeElement.value = Math.abs(numb);
        event.preventDefault();
      }
    }, 100);
  }

  validateFields(event): void {
    if (this._withFloat) {
      return;
    }

    setTimeout(() => {
      const val = this._el.nativeElement.value;
      let numb = val.match(/\d/g);

      if (this._withFloat) {
        numb = numb.join('');
      } else {
        numb = parseInt(val);
      }

      this._el.nativeElement.value = numb;

      event.preventDefault();
    }, 100);
  }

  ngOnInit(): void {
    if (this.maxValue && this._control.control) {
      this._control.control.valueChanges
        .pipe(
          takeUntilDestroyed(this._destroyRef),
          skip(1),
          filter((value) => this.maxValue && value > this.maxValue),
          map(() => {
            if (!this.skipValidation) {
              this._control.control.setValue(this.maxValue, { emitEvent: false });
            }
          })
        )
        .subscribe();
    }
  }
}
//TODO: CHECK

// @HostListener('keypress', ['$event']) onKeyPress(event) {
//   const regExp =
//     !this.allowMultipleDots && event.key === '.' && this.el.nativeElement.value.indexOf('.') !== -1
//       ? this.onlyNumbers
//       : this.regexStr;
//
//   return new RegExp(this.customRegexStr || regExp).test(event.key);
// }
//
// @HostListener('input', ['$event']) onInput() {
//   const value = this.el.nativeElement.value;
//   const decimalCheck = value.split('.');
//
//   if (decimalCheck.length > 1 && decimalCheck[1].length > 2) {
//     this.el.nativeElement.value = `${decimalCheck[0]}.${decimalCheck[1].substring(0, 2)}`;
//   }
// }
